// @ts-nocheck
import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellTech from '@/components/cells/tech';
import CellWide from '@/components/cells/wide';
import CellCurrency from '@/components/cells/currency';
import CellNumber from '@/components/cells/number';
import ColumnSelect from '@/components/column-select';
import KendoPager from '@/components/kendo/kendo-pager';
import Router from 'next/router';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import KendoCellEmployee from '@/components/kendo/cells/kendo-cell-employee';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellCurrency from '@/components/kendo/cells/kendo-cell-currency';
import KendoCellNumber from '@/components/kendo/cells/kendo-cell-number';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoTable from '@/components/kendo/kendo-table';
import { createFileRoute } from '@tanstack/react-router'



function ProjectList() {

  const toast = useContext(ToastContext);

  const [columnState, setColumnState] = useState<any[]>([]);
  const [availableColumns, setAvailableColumns] = useState<any[]>([]);
  const [requiredColumns, setRequiredColumns] = useState<any[]>([]);
  const [selectedColumns, setSelectedColumns] = useState<any[]>([]);

  const [selectedProjects, setSelectedProjects] = useState<any[]>([]);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const columns = useMemo(
    () => columnState.filter((column: any) => column.Show == true).map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
      }

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'employee':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellTech value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellEmployee {...props} employeesField="Employees" />;
            break;
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'currency':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellCurrency value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellCurrency {...props} />;
            break;
          case 'int':
          case 'int?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={false} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={false} />;
            break;
          case 'decimal':
          case 'decimal?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={true} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={true} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} />
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      if (column.ColumnName == 'LocationDisplay') {
        columnObject['Cell'] = ({ cell: { value } }: any) => <CellWide value={value} />;
      }

      return columnObject;
    }),
    [columnState, selectedProjects]
  );

  function setColumn(selected: any) {
    let newColumns = [...selectedColumns];
    if (newColumns.includes(selected)) {
      newColumns = newColumns.filter((value: any) => { return value !== selected })
    } else {
      newColumns.push(selected);
    }
    setSelectedColumns(newColumns);

    const newState = columnState.map(function (column: any) {
      if (column.Label == selected) {
        column.Show = !column.Show;
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function setReorder(updatedOptions: any) {

    const newState = updatedOptions.map((item: any, index: any) => {
      let column = columnState.find((x: any) => x.Label == item);
      column.Order = index;
      return column;
    });

    setAvailableColumns(updatedOptions);
    setColumnState(newState);

    columnMappingPut(newState);
  }

  const columnMappingPut = async (newState: any) => {
    await Fetch.put({
      url: '/Employee/ColumnMapping',
      params: {
        ColumnMappings: newState,
        model: 'ProjectList',
      },
      toastCtx: toast
    });
  }

  const [projectResults, setProjectResults] = useState([{}]);
  const [searching, setSearching] = useState(false);
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize, setPageSize] = useState(10);

  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getAccessStatus();
    (async () => {
      const columnsRes = await Fetch.get({ url: '/Employee/ColumnMapping', params: { model: 'ProjectList' } });
      const cols = columnsRes.Results;
      setColumnState(cols);
      setAvailableColumns(cols.map((c: any) => c.Label));
      setRequiredColumns(cols.filter((c: any) => c.IsRequired).map((c: any) => c.Label));
      setSelectedColumns(cols.filter((c: any) => c.Show).map((c: any) => c.Label));
    })();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    searchProjects();
  }, [currentPage]);

  useEffect(() => {
    if (currentPage == 1) {
      searchProjects();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, pageSize]);

  function setSort(field: any) {
    if (field != sortField) {
      setSortDirection('ascending');
    } else {
      if (sortDirection == 'ascending') {
        setSortDirection('descending');
      } else {
        setSortDirection('ascending');
      }
    }

    setSortField(field);
  }

  const searchProjects = async () => {

    setSearching(true);

    const projects = await Fetch.post({
      url: `/Project/GetProjects`,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        SortExpression: sortField,
        SortDirection: sortDirection
      }
    });

    setProjectResults(projects.Results);
    setTotalResults(projects.TotalResults);
    setSearching(false);
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push, '/project/[id]', `/project/${row.original.ID}`);
  }

  const createProject = () => {
    Helper.nextRouter(Router.push, "/project/create");
  };

  const getTableActions = () => {
    let acts = [
      { text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push, '/project/[id]', `/project/${row.ID}`) }
    ];

    return acts;
  };

  // for table resize columns
  async function resetColumnWidths() {
    const newState = columnState.map(function (column: any) {
      column.UserWidth = null;
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function onColumnResize(columnName: any, width: any, columnNamesAndWidths: any) {
    const newState = columnState.map(function (column: any) {
      if (column.ColumnName === columnName) {
        column.UserWidth = width;
      } else if (columnNamesAndWidths) {
        let match = columnNamesAndWidths.find((x: any) => x.columnName === column.ColumnName);
        if (match) {
          column.UserWidth = match.width;
        }
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }
  // for table resize columns

  return (
    <div className="list-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Project List', link: '/project/list', type: 'list' }} />
        </div>
        <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
          text="Create" icon="plus-circle" extraClasses="fit-content no-margin" onClick={createProject} />
      </div>
      <div className="row end padded">
        <div className="search-container">
          <Search
            placeholder="Search customer or job card"
            resultsNum={projectResults.length}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </div>
        <div className="row end">
          <ColumnSelect options={availableColumns} selected={selectedColumns} requiredColumns={requiredColumns} setColumn={setColumn} setReorder={setReorder}
            resetColumnWidths={resetColumnWidths} />
        </div>
      </div>

      <div className={"no-items" + (projectResults.length == 0 ? " no-items-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <img src="/job-folder.svg" alt="Project Folder" />
        <h3>No projects found</h3>
        <p>If you can't find a project, try another search or create a new one.</p>
        <a href="/project/create"><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new project</a>
        <img className="wave" src="/wave.svg" alt="wave" />
      </div>

      {projectResults.length != 0 ? <KendoTable
        searching={searching}
        actions={getTableActions()}
        columns={columns}
        data={projectResults}
        rowClick={rowClick}
        setSort={setSort}
        sortField={sortField}
        sortDirection={sortDirection}
        type="Project"
        onColumnResize={onColumnResize}
        heightOffset={260}
        highlightColumnName="ProjectNumber"
      /> : ""}

      <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal}  parentPageNumber={currentPage}/>

      <style jsx>{`
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .padded {
          padding-bottom: 1rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
        .select-actions {
          display: flex;
          margin-left: -1rem;
        }
        .select-actions :global(.white-action) {
          font-size: 0.875rem;
          margin: 0 0 0 1rem; 
          width: auto;
        }
        .select-actions :global(.icon) {
          left: 1rem !important;
        }
      `}</style>
    </div>
  );
}

export default ProjectList;

export const Route = createFileRoute('/_authenticated/project/list')({ component: ProjectList })
